import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import { supabase, checkSupabaseConnection } from './config/supabase';

// Check Supabase connection on startup in development mode
if (import.meta.env.DEV) {
  console.log('Application starting in development mode');
  console.log('Current URL:', window.location.href);
  
  checkSupabaseConnection()
    .then(result => {
      if (result.connected) {
        console.log('✅ Supabase connection successful');
      } else {
        console.error('❌ Supabase connection failed:', result.error);
      }
    });
}

// Add global error handler
window.addEventListener('error', (event) => {
  console.error('Global error:', event.error);
});

// Create root element
const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('Root element not found!');
} else {
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}